module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper short-contents"
  }, [_c('header', {
    staticClass: "gheader -white"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": _vm.goTop
    }
  }, [_vm._v("戻る")])])]), _c('div', {
    staticClass: "container bg01 txtC willmustsent short-contents"
  }, [_c('div', {
    staticClass: "willmustsent__sec01"
  }, [_c('h2', {
    staticClass: "fz18 bold mb15 brown"
  }, [_vm._v("送信しました！")]), _c('p', {
    staticClass: "mb15 fz13"
  }, [_vm._v("がんばってこうニャン！")]), _vm._m(0), _c('button', {
    staticClass: "btn02",
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goWillMustList
    }
  }, [_c('span', [_vm._v("あなたのMUST・WILL一覧")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "willmustsent__sec01__img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_05.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0fb88c50!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/will-must-sent.pug
// module id = 1387
// module chunks = 1